import { gatewayInstance } from "../../axiosInstance";
import { SERVICE_ENDPOINT } from "../../const";

export const searchTransporterInvoices = async (request) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/transporter-invoice/search",
      request,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const searchInvoiceJobs = async ({ request, searchText }) => {
  try {
    const response = await gatewayInstance.post(
      `${SERVICE_ENDPOINT.TRANSPORT}/invoice/jobs`,
      {
        ...request,
        searchText: searchText,
      },
    );
    return response.data.map((item) => ({
      key: item.jobId,
      title: item.jobCode,
      value: item.jobCode,
    }));
  } catch (e) {
    console.error(e);
  }
};

export const searchTransporterCharges = async (request) => {
  try {
    const response = await gatewayInstance.post(
      "/financeservice/transporter-charges/search",
      request,
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const searchDownloadTransporterChargesExcel = async (request) => {
  try {
    const response = await gatewayInstance.post(
        "/financeservice/transporter-charges/downloadExcel",
        request,
        {
          responseType: "blob",
        }
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};
export const searchDownloadTransporterChargesPdf = async (request) => {
  try {
    const response = await gatewayInstance.post(
        "/financeservice/transporter-charges/downloadPdf",
        request,
        {
          responseType: "blob",
        }
    );
    return response.data;
  } catch (e) {
    console.error(e);
    throw e;
  }
};

export const TransporterChargesById = async (id) => {
  try {
    const response = await gatewayInstance.post(
      `/financeservice/transporter-charges/${id}`,
    );
    console.log("transporter-charges", response);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const updateTransporterCharge = async (data) => {
  console.log("add data", data);
  const response = await gatewayInstance.post(
    `/financeservice/transporter-charges/add-update`,
    data,
  );
  console.log("api response", response);
  return response.data;
};

export const getTransportChargeReview = async(data)=>{
  const response = await gatewayInstance.post(
    `/financeservice/charges-review/job`, data
  );
  return response.data;
}

export const approveChargeReview = async(data)=>{
  const response = await gatewayInstance.post(
    `/financeservice/transporter-charges/approve`, data
  );
  return response.data;
}
